import type { CreateUserOutcome } from "@/services/frontendServices/usersServices";

export type AddUserOutcomeToast = {
  level: "success" | "warning";
  title: string;
  description: string;
};

/**
 * What Add User tells the admin. The endpoint may have reconciled an existing
 * WorkOS account rather than inviting, so each outcome says what actually
 * happened - saying "invited" would promise an email nobody sent, and a role the
 * invitee will not get must never read as applied (SKR-894).
 */
export function describeAddUserOutcome(
  outcome: CreateUserOutcome
): AddUserOutcomeToast {
  switch (outcome) {
    case "reconciled_active":
    case "reactivated":
      return {
        level: "success",
        title: "User added successfully!",
        description:
          "They already had an account, so no invitation was needed.",
      };
    case "reconciled_pending":
      return {
        level: "success",
        title: "User added successfully!",
        description:
          "An invitation was already pending, so we didn't send another.",
      };
    case "pending_role_not_applied":
      return {
        level: "warning",
        title: "User added, role not applied yet",
        description:
          "An invitation with a different role is already pending. Cancel it and add the user again for the new role to apply.",
      };
    case "invite_failed":
      return {
        level: "warning",
        title: "User added, invitation not sent",
        description:
          "The user was created, but the invitation could not be sent. Use Send Invitation to retry.",
      };
    case "invited":
    default:
      return {
        level: "success",
        title: "User added successfully!",
        description: "User has been invited.",
      };
  }
}
